import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" {...props}><path fill="#1E1E1E" d="M10.778 0c5.952 0 10.778 4.825 10.778 10.778 0 2.616-.933 5.014-2.483 6.88l4.634 4.635a1 1 0 01-1.414 1.414l-4.634-4.634a10.734 10.734 0 01-6.881 2.483C4.825 21.556 0 16.73 0 10.778 0 4.825 4.825 0 10.778 0zm0 2a8.778 8.778 0 106.11 15.08 1.009 1.009 0 01.191-.194A8.778 8.778 0 0010.778 2z" /></svg>;